<!--<span ngbDropdown>
    <button class="PGShare btn btn-white" ngbDropdownToggle>
        <i class="fa-regular fa-lg fa-share-nodes"></i>
    </button>

    <div ngbDropdownMenu class="dropdown-menu">
        @for(social of availableSocials; track social)  {
            <div class="dropdown-item" (click)="doShare(social.id)">
                <i class="fa-brands fa-fw fa-{{ social.id }} me-2"></i>
                <span>{{ social.label }}</span>
            </div>
        }
    </div>
</span>-->

<button class="PGShare btn {{ buttonClass || 'btn-white' }}" (click)="doWebShare()">
    <i class="fa-regular fa-lg fa-share-nodes"></i>
    @if(!isSmall) {
        <span>{{ 'pg-share.share' | locTranslate }}</span>
    }
</button>